import { nativeLensId } from './nativeLensId';
import { nativePageParams, nativePageRoutes } from './pageRoutes';

/** Report state belongs only to reopening that report, never another Lens or workspace area. */
export function nativeWorkspaceParams(pathname: string, search: string, destinationLensId?: string): URLSearchParams {
  const sameReport = nativePageRoutes.some(
    (page) => page.path === pathname && nativeLensId(page.pageId) === destinationLensId,
  );
  return sameReport ? nativePageParams(search) : new URLSearchParams();
}
